import React from 'react'
import styled from 'react-emotion'

import { TwoCol, LeftCol, RightCol, } from '../two-col'
import SectionHeader from '../section/SectionHeader'
import SubHeader from '../section/SubHeader'
import HubspotForm from './HubspotForm'

import hatman from '../../assets/hat.png'

const Wrapper = styled.div`
  margin-bottom: 5rem;
`


const HubspotFormSection = (props) => {
  return (
    <TwoCol>
      <LeftCol image bgImgSrc={hatman}>
      </LeftCol>
      <RightCol color={'#fff'} bgColor={props.primary ? '#18aa7a' : '#fcc71b'} skew>
        <SectionHeader align="center">Book a Demo Today</SectionHeader>
        <SubHeader align="center">Fill the form below, select a convenient time and one of our Whistlers will confirm your 30 minute demo. </SubHeader>
        <Wrapper>
          <HubspotForm
            id={props.id || 'book-demo'}
            formId={props.formId || "7d86c04f-e98e-42eb-ae79-ff2b14c7605a"}
            trackingId={props.trackingId}
          />
        </Wrapper>
      </RightCol>
    </TwoCol>
  );
}
 
export default HubspotFormSection;


// WEBPACK FOOTER //
// ./src/components/forms/HubspotFormSection.js